module.exports = __webpack_public_path__ + "static/media/Thought-leaders-parched-land.61c3b04a.jpg";